import { Link } from 'react-router-dom';
import { homeTiles } from '../data/media.js';
import './TileGrid.css';

export default function TileGrid() {
  return (
    <ul className="tiles" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {homeTiles.map((tile) => (
        <li key={tile.href} style={{ display: 'flex' }}>
          <Link to={tile.href} className="tile" style={{ flex: 1 }}>
            <div className="tile__media">
              {/* Decorative: the tile title already names the destination, so
                  repeating it in alt text would double-announce the link. */}
              <img src={tile.image} alt="" loading="lazy" decoding="async" />
              <span className="tile__eyebrow">{tile.eyebrow}</span>
            </div>

            <div className="tile__body">
              <h3 className="tile__title">{tile.title}</h3>
              <p className="tile__text">{tile.description}</p>
              <span className="tile__cue">
                Explore
                <svg
                  className="arrow"
                  width="14"
                  height="10"
                  viewBox="0 0 14 10"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M1 5h11M8.5 1L12.5 5L8.5 9"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}
